import { render, staticRenderFns } from "./Industrias.vue?vue&type=template&id=695812f6&scoped=true&"
import script from "./Industrias.vue?vue&type=script&lang=js&"
export * from "./Industrias.vue?vue&type=script&lang=js&"
import style0 from "./Industrias.vue?vue&type=style&index=0&id=695812f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695812f6",
  null
  
)

export default component.exports